import { render, staticRenderFns } from "./NavBarMain.vue?vue&type=template&id=0c5fa365&"
import script from "./NavBarMain.vue?vue&type=script&lang=js&"
export * from "./NavBarMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports